module.exports = __webpack_public_path__ + "static/media/care_device_edit.201a2b3f.svg";